import {EVENTS_NAME} from '../../config.js'

const {LEAD_TRIGGERED_DETAIL_PROFESSIONAL} = EVENTS_NAME

// INPUT:  event='Lead Triggered', lead_type='Financed Purchase Email'|'Financed Purchase Phone Called', page_name_origin='detail', seller_type='profesional'
// OUTPUT: ['Leads en detalle de profesionales (web)']

export const getProfessionalDetailEvents = ({event, properties, isProfessionalSeller}) => {
  const matches =
    event === LEAD_TRIGGERED_DETAIL_PROFESSIONAL.EVENT &&
    (properties.lead_type === LEAD_TRIGGERED_DETAIL_PROFESSIONAL.LEAD_TYPE ||
      properties.lead_type === LEAD_TRIGGERED_DETAIL_PROFESSIONAL.LEAD_TYPE_1) &&
    properties.page_name_origin === LEAD_TRIGGERED_DETAIL_PROFESSIONAL.PAGE_NAME_ORIGIN &&
    isProfessionalSeller

  if (!matches) return []

  return [LEAD_TRIGGERED_DETAIL_PROFESSIONAL.EVENT_OPTIMIZELY]
}
